import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Document, Page, pdfjs } from "react-pdf";
import { useParams, useLocation } from "react-router-dom";
import "../Units/UnitView.css";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

// Update PDF worker configuration
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.worker.min.js`;

function UnitView() {
  const { id } = useParams();
  const [contentData, setContentData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const containerRef = useRef(null);
  const location = useLocation();
  const { coursesname, chaptername, unitname } = location.state || {};

  // Helper function to render HTML content
  // Helper function to render HTML content
  const renderHTMLContent = (content) => {
    if (!content) return null;

    // Handle escaped HTML tags
    const decodedContent = content
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&amp;/g, "&");

    return (
      <div
        dangerouslySetInnerHTML={{ __html: decodedContent }}
        className="content-text"
      />
    );
  };

  useEffect(() => {
    const fetchUnit = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/unit/ui/${id}`
        );
        if (response.data && response.data.unitsPlans) {
          setContentData(response.data.unitsPlans);
        } else {
          setError("No units plans found");
        }
      } catch (err) {
        setError(err.message || "Failed to fetch unit data");
      } finally {
        setLoading(false);
      }
    };
    fetchUnit();
  }, [id]);

  // Handle PDF loading success
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  // Add cleanup for fullscreen
  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        setIsFullScreen(false);
      }
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const toggleFullScreen = async () => {
    try {
      if (!document.fullscreenElement) {
        await containerRef.current.requestFullscreen();
        setIsFullScreen(true);
      } else {
        await document.exitFullscreen();
        setIsFullScreen(false);
      }
    } catch (err) {
      console.error("Error toggling fullscreen:", err);
    }
  };

  const handleClickOpen = (imageSrc) => {
    setSelectedImage(imageSrc);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage("");
  };

  return (
    <>
      {/* <div className="unit-header">
        <h1>{contentData.unitname}</h1>
        <div className="unit-meta">
          <span>Course: {coursesname}</span>
          <span>Chapter: {chaptername}</span>
          <span>Duration: {contentData.duration} minutes</span>
        </div>
      </div> */}
      <div
        ref={containerRef}
        className={`container ${isFullScreen ? "fullscreen" : ""}`}
        style={{ backgroundColor: isFullScreen ? "#1b2431" : "initial" }}
      >
        {/* Main Content Section */}
        {loading ? (
          <div className="loading">Loading...</div>
        ) : (
          contentData.units_content &&
          contentData.units_content.length > 0 &&
          contentData.units_content.map((item, index) => {
            switch (item.type) {
              case "unitHeading":
                return (
                  <section key={index} className="unit-heading">
                    <h1>{item.data} hi</h1>
                  </section>
                );
              case "Heading1":
                return (
                  <section key={index} className="heading1">
                    <h1>{item.data}</h1>
                  </section>
                );
              case "Heading2":
                return (
                  <section key={index} className="heading2">
                    <h2>{item.data}</h2>
                  </section>
                );
              case "Paragraph":
                return (
                  <div
                    key={index}
                    style={{
                      marginTop: "20px",
                      padding: "20px",
                      color: "#fff", // Set text color to white
                      backgroundColor: "#273142",
                    }}
                  >
                    <style>
                      {`
                              .ql-size-small {
                                font-size: 12px;
                              }
                              .ql-size-large {
                                font-size: 20px;
                              }
                              .ql-size-huge {
                                font-size: 30px;
                              }
                              .ql-align-justify {
                                text-align: justify;
                              }
                              .ql-align-center {
                                text-align: center;
                              }
                              .ql-align-right {
                                text-align: right;
                              }
                              .ql-font-monospace {
                                font-family: monospace;
                              }
                              em {
                                font-style: italic;
                              }
                                  u {
                                text-decoration: underline;
                              }
                              strong {
                                font-weight: bold;
                              }
                                  /* Custom styles for unordered list and list items */
                               ul {
                                  list-style-type: disc; /* Default bullet points */
                                 margin-left: 20px; /* Indent the list slightly */
                                    }
                              li {
                                margin-bottom: 5px; /* Add some space between list items */
                              }
                            `}
                    </style>
                    <div dangerouslySetInnerHTML={{ __html: item.data }} />
                  </div>
                );
              case "PDF":
                return (
                  <section
                    key={index}
                    style={{ width: "100%", marginLeft: "0px" }}
                  >
                    {item.data.map((url, pdfIndex) => (
                      <section
                        key={pdfIndex}
                        style={{
                          marginBottom: "16px",
                          borderRadius: "8px",
                          backgroundColor: "#fff",
                          width: "100%",
                          overflow: "hidden",
                        }}
                      >
                        <Document
                          file={url}
                          onLoadSuccess={onDocumentLoadSuccess}
                          onLoadError={setError}
                          loading={
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                padding: "16px",
                              }}
                            >
                              Loading...
                            </div>
                          }
                          style={{
                            width: "100% !important",
                            height: "auto",
                          }}
                        >
                          {Array.from(new Array(numPages), (el, pageIndex) => (
                            <section
                              key={`page_${pageIndex + 1}`}
                              style={{
                                marginBottom: "16px"
                              }}
                            >
                              <Page
                                pageNumber={pageIndex + 1}
                                renderTextLayer={false}
                                renderAnnotationLayer={false}
                                scale={0.8}
                                width={window.innerWidth}
                              />
                            </section>
                          ))}
                        </Document>
                      </section>
                    ))}
                  </section>
                );
              case "gallery":
                return (
                  <section key={index} className="gallery">
                    {item.data.map((url, i) => (
                      <div key={i} className="gallery-item">
                        <img
                          src={url}
                          alt="Gallery"
                          onClick={() => handleClickOpen(url)}
                        />
                      </div>
                    ))}
                    {open && (
                      <div className="image-popup">
                        <span className="close" onClick={handleClose}>
                          ×
                        </span>
                        <img src={selectedImage} alt="Selected" />
                      </div>
                    )}
                  </section>
                );
              case "videoUpload":
                return (
                  <section key={index} className="video-container">
                    <video
                      controls
                      preload="auto"
                      onError={(e) => {
                        console.error("Error loading video:", e);
                      }}
                    >
                      <source src={item.data[0]} type="video/mp4" />
                      <source src={item.data[0]} type="video/webm" />
                      Your browser does not support the video tag.
                    </video>
                  </section>
                );
              case "Singleimage":
                return (
                  <section
                    key={index}
                    style={{ width: "100%", marginTop: "20px" }}
                  >
                    <img
                      src={item.data}
                      alt="Gallery"
                      onClick={() => handleClickOpen(item.data)}
                      style={{
                        width: "100%",
                        height: "auto",
                      }}
                    />
                    {open && (
                      <div
                        style={{
                          position: "fixed",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          backgroundColor: "rgba(0, 0, 0, 0.7)",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          zIndex: 1000,
                        }}
                        onClick={handleClose}
                      >
                        <div
                          style={{
                            position: "relative",
                            maxWidth: "90%",
                            maxHeight: "90%",
                            backgroundColor: "#fff",
                            padding: "20px",
                            boxSizing: "border-box",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <img
                            src={selectedImage}
                            alt="Selected"
                            style={{
                              width: "100%",
                              height: "auto",
                              maxHeight: "80vh",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </section>
                );
              case "youtubeUrl":
                return (
                  <section key={index} className="youtube-url">
                    <iframe
                      width="100%"
                      height="920px"
                      src={`https://www.youtube.com/embed/${
                        item.youtubeUrl.split("v=")[1]
                      }`}
                      title="YouTube Video"
                      frameBorder="0"
                      allowFullScreen
                    />
                  </section>
                );
              case "vimeoUrl":
                return (
                  <section key={index} className="vimeo-url">
                    <iframe
                      src={`https://player.vimeo.com/video/${item.vimeoUrl
                        .split("/")
                        .pop()}`}
                      width="100%"
                      height="920px"
                      title="Vimeo Video"
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowFullScreen
                    />
                  </section>
                );
              default:
                return null;
            }
          })
        )}
      </div>
      {/* Updated Fullscreen Button */}
      <div className="fullscreen-button">
        <Tooltip title={isFullScreen ? "Exit Fullscreen" : "Enter Fullscreen"}>
          <IconButton
            onClick={toggleFullScreen}
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.9)",
              },
            }}
          >
            {isFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </IconButton>
        </Tooltip>
      </div>
    </>
  );
}

export default UnitView;
